import type { Gender } from '../../types'

// «Ж»/«М» — не копирайт-реплика Луни, а фиксированный грамматический символ (спека 02 §A1:
// «формулировка «укажите пол» запрещена», «без эмодзи»), поэтому не заведён ключом в 08_copy.md —
// хранится тут же, рядом с компонентом, а не в modules/lunya/copy.
export const GENDER_LABELS: Readonly<Record<Gender, string>> = {
  f: 'Ж',
  m: 'М',
}

export const GENDER_ORDER: readonly Gender[] = ['f', 'm']
